import "./polyfill";
import App from "./App";
import register from "preact-custom-element";

/*
 * <route-protect-widget status={false} quote={'R$10,00'} payer={'merchant'} mode={'dark'} alignment={'center'} />
 * */

register(
  App,
  "route-protect-widget",
  [
    "status",
    "quote",
    "payer",
    "mode",
    "alignment",
    "variant",
    "logo",
    "heading",
    "subheading",
    "primarycolor",
    "secondarycolor",
    "fontfamily",
  ],
  {
    shadow: false,
  }
);
